import { useEffect, useState } from 'react';
import { AlertTriangle, RefreshCw, ShieldAlert } from 'lucide-react';
import { api } from '../lib/api';

type Item={
  key:string;storedEnabled:boolean;effectiveEnabled:boolean;source:string;reason:string;updatedAt:string;updatedBy?:string|null;
};
type Ready={
  ready:boolean;release:string;environment:string;
  version:{id?:string|null;tag?:string|null;timestamp?:string|null};
  checks:Array<{name:string;ok:boolean;detail:string}>;
};

const labels:Record<string,string>={
  maintenance_mode:'Maintenance mode',
  disable_ai_generation:'Disable AI generation',
  disable_exports:'Disable print/Kindle exports',
  disable_billing_enrollment:'Disable billing enrollment/changes',
  disable_project_creation:'Disable new project creation',
};

export default function ReleaseControls(){
  const[items,setItems]=useState<Item[]>([]);
  const[ready,setReady]=useState<Ready|null>(null);
  const[message,setMessage]=useState('');
  const load=async()=>{
    const[a,b]=await Promise.all([
      api.get<{items:Item[]}>('/api/admin/runtime-controls'),
      api.get<Ready>('/api/admin/release/readiness'),
    ]);
    setItems(a.data.items);setReady(b.data);
  };
  useEffect(()=>{load().catch(e=>setMessage(e instanceof Error?e.message:'Release controls could not load.'));},[]);
  return <section className="card p-6 mt-6">
    <div className="row items-start"><div><span className="eyebrow">RELEASE CANDIDATE CONTROLS</span><h2>Readiness & emergency switches.</h2><p className="muted">D1 switches can be changed without redeploying. Environment kill switches always override them.</p></div><button className="secondary" onClick={()=>load()}><RefreshCw size={14}/>Refresh</button></div>
    {ready&&<div className="grid md:grid-cols-[220px_1fr] gap-4 mt-5">
      <div className="softBox"><b>Runtime readiness</b><strong>{ready.ready?'READY':'BLOCKED'}</strong><small>{ready.release} · {ready.environment}</small>{ready.version.id&&<small>Version {ready.version.id.slice(0,12)}</small>}</div>
      <div className="grid sm:grid-cols-2 gap-2">{ready.checks.map(check=><div className="softBox" key={check.name}><div className="flex gap-2 items-center">{check.ok?<span>✓</span>:<AlertTriangle size={15}/>}<b>{check.name}</b></div><p className="text-xs muted mt-1">{check.detail}</p></div>)}</div>
    </div>}
    <h3 className="mt-6">Emergency controls</h3>
    <div className="space-y-3 mt-3">{items.map(item=><div className="softBox" key={item.key}>
      <div className="row items-start"><div><b>{labels[item.key]||item.key}</b><div className="text-xs muted">{item.effectiveEnabled?'ENABLED':'disabled'} · source {item.source}{item.updatedBy?` · ${item.updatedBy}`:''}</div>{item.reason&&<p className="text-sm mt-2">{item.reason}</p>}</div><button className={item.effectiveEnabled?'primary':'secondary'} onClick={async()=>{const enabled=!item.storedEnabled;const reason=enabled?(prompt('Emergency reason:','Operational protection')||'Operational protection'):'';await api.put(`/api/admin/runtime-controls/${item.key}`,{enabled,reason});await load();setMessage(`${labels[item.key]||item.key} ${enabled?'enabled':'disabled'}.`)}}><ShieldAlert size={14}/>{item.storedEnabled?'Disable switch':'Enable switch'}</button></div>
    </div>)}</div>
    {message&&<div className="hint mt-4">{message}</div>}
  </section>
}
